export const AUTHS_KEY = 'auths';
export const WebHookSecretKey = 'WebHookSecretKey';
